var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLamps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0000305176,
    width: 44,
    height: 44,
    rx: 4,
    fill: "#E0F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8 20.2094L20.121 21.3977C19.9566 21.6854 19.5901 21.7854 19.3024 21.621C19.0146 21.4566 18.9147 21.0901 19.0791 20.8024L20.0186 19.1582C20.3641 18.5536 21.236 18.5536 21.5815 19.1582L22 19.8907L22.4186 19.1582C22.7641 18.5536 23.636 18.5536 23.9815 19.1582L24.921 20.8024C25.0854 21.0901 24.9854 21.4566 24.6977 21.621C24.41 21.7854 24.0435 21.6854 23.8791 21.3977L23.2 20.2094L22.7815 20.9419C22.436 21.5465 21.5641 21.5465 21.2186 20.9419L20.8 20.2094Z",
    fill: "url(#paint0_linear_1403_5445)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 13.3C18.9999 13.3 16.6 15.6526 16.6 18.5154C16.6 19.9351 17.0545 21.1929 17.8757 22.1108C18.7348 23.071 19.7429 24.3355 19.7429 25.8715V25.9923C19.7429 26.2552 19.9681 26.5 20.2857 26.5H23.7143C24.0319 26.5 24.2572 26.2552 24.2572 25.9923V25.8715C24.2572 24.3355 25.2653 23.071 26.1243 22.1108C26.9455 21.1929 27.4 19.9351 27.4 18.5154C27.4 15.6526 25.0002 13.3 22 13.3ZM15.4 18.5154C15.4 14.9548 18.3728 12.1 22 12.1C25.6273 12.1 28.6 14.9548 28.6 18.5154C28.6 20.1905 28.0617 21.745 27.0187 22.9109C26.1435 23.8891 25.4572 24.8419 25.4572 25.8715V25.9923C25.4572 26.5845 25.1539 27.0955 24.7 27.4004V28.6V29.8C24.7 30.2971 24.2971 30.7 23.8 30.7H20.2C19.703 30.7 19.3 30.2971 19.3 29.8V28.6V27.4004C18.8461 27.0955 18.5429 26.5845 18.5429 25.9923V25.8715C18.5429 24.8419 17.8566 23.8892 16.9814 22.9109C15.9383 21.745 15.4 20.1905 15.4 18.5154ZM20.5 27.7V28H23.5V27.7H20.5ZM23.5 29.2H20.5V29.5H23.5V29.2Z",
    fill: "url(#paint1_linear_1403_5445)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2 31.6C20.2 31.2687 20.4686 31 20.8 31H23.2C23.5314 31 23.8 31.2687 23.8 31.6C23.8 31.9314 23.5314 32.2 23.2 32.2H20.8C20.4686 32.2 20.2 31.9314 20.2 31.6Z",
    fill: "url(#paint2_linear_1403_5445)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1403_5445",
    x1: 22,
    y1: 18.7047,
    x2: 22,
    y2: 21.7001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1403_5445",
    x1: 22,
    y1: 12.1,
    x2: 22,
    y2: 30.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1403_5445",
    x1: 22,
    y1: 31,
    x2: 22,
    y2: 32.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DC3E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47B972"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamps);
export default __webpack_public_path__ + "static/media/lamps.3f17638a608a88ade0dcaecd7c347304.svg";
export { ForwardRef as ReactComponent };